import React, { ReactNode } from 'react';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';

import styles from './drag-list-container.scss';

interface DragListContainerProps {
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}

export const DragListContainer: React.FC<DragListContainerProps> = ({ children, header, footer }) => {

  return <MainGridContainer>
    {!!header && header}
    <div className={styles.container}>
      <div className={`row expanders-in-equal-cols ${styles.list}`}>
        {children}
      </div>
      {!!footer && <div className={styles.buttons}>
        {footer}
      </div>}
    </div>
  </MainGridContainer>;
};
